import dayjs from 'dayjs';

export const getISO_8601Date = (date?: Date | null) => {
  return dayjs(date ?? Date()).format('YYYY-MM-DD');
};

export const dateFromString = (date?: string) => {
  return date ? new Date(date) : undefined;
};

export const notBeforeToday = (date?: Date | null): Date =>
  date && !dayjs(date).isBefore(dayjs(), 'day') ? date : new Date();

export const getLLDate = (date?: Date | null | string) => {
  return date ? dayjs(date).format('ll') : undefined;
};

export const getLLDateWithTime = (date?: Date | null | string) => {
  return date ? `${getLLDate(date)}, ${dayjs(date).format('HH:mm')}` : undefined;
};
